import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

// Prosty toggle: jeden przycisk, klik przełącza light ↔ dark. Wybór trafia
// do localStorage (klucz "theme"). Ikona pokazuje stan docelowy.
export function ThemeToggle({ className = "" }: { className?: string }) {
  const { resolved, setTheme } = useTheme();
  const next = resolved === "dark" ? "light" : "dark";
  const label = resolved === "dark" ? "Włącz tryb jasny" : "Włącz tryb ciemny";
  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={label}
      title={label}
      className={
        "inline-flex h-10 w-10 items-center justify-center rounded-lg border border-border bg-background/50 text-foreground transition hover:bg-accent/20 " +
        className
      }
    >
      {resolved === "dark"
        ? <Sun className="h-5 w-5" aria-hidden="true" />
        : <Moon className="h-5 w-5" aria-hidden="true" />}
    </button>
  );
}
